import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 4v16l13 -8l-13 -8","key":"svg-0"}]]

const IconPlayerPlay = createReactComponent('outline', 'player-play', 'PlayerPlay', __iconNode);

export default IconPlayerPlay;